/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotesTemplate } from '../../models/notes-template';

export interface NotesTemplateFindTemplatesByCategory$Params {
  CategoryId: string | null;
}

export function notesTemplateFindTemplatesByCategory(http: HttpClient, rootUrl: string, params: NotesTemplateFindTemplatesByCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NotesTemplate>>> {
  const rb = new RequestBuilder(rootUrl, notesTemplateFindTemplatesByCategory.PATH, 'get');
  if (params) {
    rb.path('CategoryId', params.CategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NotesTemplate>>;
    })
  );
}

notesTemplateFindTemplatesByCategory.PATH = '/api/NotesTemplate/note/{CategoryId}';
